import JwtService from "../../../utils/jwt.service";

export default {
  errors: null,
  user: {},
  billings: [],
  billingsCount: 0,
  isLoading: true,
  isAuthenticated: !!JwtService.getToken(),
  hasOpenInvoice: false,
  isAdmin: false,
  accessLevel: 0,
  message: [],
  loading: false,
  price:0,
  credit:0,
  client:{},
  address:{}
};
